module.exports = __webpack_public_path__ + "static/media/icon-word.fac2ba22.jpg";